/* MCR cinematic hero: CSS-driven autoplay progress, swipe, keyboard, pause on hover/out-of-view, lazy slide videos. */
(function () {
  'use strict';
  if (window.customElements.get('mcr-hero')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class McrHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.mcr-hero__slide'));
      if (this.slides.length < 2 && !this.querySelector('video[data-src]')) return;
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.mcr-hero__dot'));
      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true' && !reduce && !window.Shopify?.designMode;
      if (!this.autoplay) this.classList.remove('mcr-hero--autoplay');
      this.hovered = false;
      this.userPaused = false;
      this.offscreen = false;
      // hold the first slide until the visitor engages (see MCRWhenEngaged in layout/theme.liquid)
      this.waiting = !!(this.autoplay && window.MCRWhenEngaged);
      var selfH = this;
      this.bind();
      this.updatePause();
      // later slides keep their photos in data-* (sections/mcr-hero.liquid); fetch the next one once the visitor engages
      if (window.Shopify && window.Shopify.designMode) this.slides.forEach(function (s, k) { selfH.loadSlide(k); });
      else if (window.MCRWhenEngaged) window.MCRWhenEngaged(function () { selfH.loadSlide(1); });
      else this.loadSlide(1);
      if (this.waiting) window.MCRWhenEngaged(function () { selfH.waiting = false; selfH.updatePause(); });
      this.playVideo(0);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      document.removeEventListener('visibilitychange', this._vis);
    }

    bind() {
      var self = this;
      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { self.go(i); });
        dot.addEventListener('animationend', function (e) {
          if (e.target.parentElement && e.target.parentElement.parentElement === dot && self.autoplay) self.go(self.index + 1);
        });
      });
      var prev = this.querySelector('.mcr-hero__prev');
      var next = this.querySelector('.mcr-hero__next');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });

      this.toggleBtn = this.querySelector('.mcr-hero__toggle');
      if (this.toggleBtn) {
        if (!this.autoplay) this.toggleBtn.hidden = true;
        this.toggleBtn.addEventListener('click', function () {
          self.userPaused = !self.userPaused;
          self.classList.toggle('is-user-paused', self.userPaused);
          self.toggleBtn.setAttribute('aria-label', self.userPaused ? self.toggleBtn.dataset.labelPlay : self.toggleBtn.dataset.labelPause);
          self.updatePause();
        });
      }

      if (this.dataset.pauseHover === 'true') {
        this.addEventListener('mouseenter', function () { self.hovered = true; self.updatePause(); });
        this.addEventListener('mouseleave', function () { self.hovered = false; self.updatePause(); });
      }
      this.addEventListener('focusin', function () { self.focused = true; self.updatePause(); });
      this.addEventListener('focusout', function () { self.focused = false; self.updatePause(); });

      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { self.go(self.index - 1); }
        else if (e.key === 'ArrowRight') { self.go(self.index + 1); }
      });

      // Swipe
      var sx = 0, sy = 0, tracking = false;
      this.addEventListener('touchstart', function (e) {
        tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      this.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) self.go(self.index + (dx < 0 ? 1 : -1));
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          self.offscreen = !entries[0].isIntersecting;
          self.updatePause();
        }, { threshold: 0.15 });
        this.io.observe(this);
      }
      this._vis = function () { self.updatePause(); };
      document.addEventListener('visibilitychange', this._vis);
    }

    updatePause() {
      var paused = this.waiting || this.userPaused || this.hovered || this.focused || this.offscreen || document.hidden;
      this.classList.toggle('is-paused', !!paused);
      var v = this.slides[this.index] && this.slides[this.index].querySelector('video');
      if (v && v.dataset.loaded) {
        if (this.offscreen || document.hidden || this.userPaused) v.pause();
        else if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
    }

    loadSlide(k) {
      var slide = this.slides[k];
      if (!slide) return;
      slide.querySelectorAll('picture [data-srcset], picture img[data-src]').forEach(function (el) {
        if (el.dataset.srcset) { el.setAttribute('srcset', el.dataset.srcset); el.removeAttribute('data-srcset'); }
        if (el.dataset.src) { el.setAttribute('src', el.dataset.src); el.removeAttribute('data-src'); }
      });
    }

    go(i) {
      var n = this.slides.length;
      if (n < 2) return;
      i = (i + n) % n;
      if (i === this.index) return;
      this.loadSlide(i);
      this.loadSlide((i + 1) % n);
      var prev = this.index;
      this.index = i;
      this.slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.classList.toggle('is-entering', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
      this.dots.forEach(function (d, k) {
        d.classList.remove('is-active');
        d.classList.toggle('is-done', k < i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      var dot = this.dots[i];
      if (dot) { void dot.offsetWidth; dot.classList.add('is-active'); }
      this.stopVideo(prev);
      this.playVideo(i);
    }

    playVideo(i) {
      var slide = this.slides[i];
      var v = slide && slide.querySelector('video[data-src]');
      if (!v || reduce) return;
      var conn = navigator.connection;
      if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
      if (!v.dataset.loaded) {
        v.src = v.dataset.src;
        v.dataset.loaded = '1';
        v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
      }
      if (!this.offscreen && !document.hidden) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }

    stopVideo(i) {
      var v = this.slides[i] && this.slides[i].querySelector('video');
      if (v && !v.paused) v.pause();
    }
  }

  customElements.define('mcr-hero', McrHero);

  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('mcr-hero');
    if (!hero || !hero.slides) return;
    var idx = hero.slides.indexOf(e.target);
    if (idx > -1) { hero.userPaused = true; hero.updatePause(); hero.go(idx); }
  });
})();
